var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1882.546,
    height: 1358.848,
    viewBox: "0 0 1882.546 1358.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Family_error",
    "data-name": "Family error",
    transform: "translate(-282.042 -7920.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M1568.719,1353.176c243.5-236.792,255.965-599.889-183.586-1007.086-63.752-59.2-94.908-141.644-158.181-185.982C1035.218,25.654,766.072,52.977,596.626,252.62,503.875,361.909,466.487,511.941,370.14,619.073,262.05,739.386,132.63,856.344,83.5,1020.277c-32.595,108.57-27.083,226.966,10.066,333.139C627.543,1448.325,1132.284,1477.564,1568.719,1353.176Z",
    transform: "translate(334.197 7843.709)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "_0893c375e0803b4dc080a9ee69a2bae3",
    "data-name": "0893c375e0803b4dc080a9ee69a2bae3",
    transform: "translate(267 7964.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M330.072,502.819H700.248V942.025H330.072Z",
    transform: "translate(279.013 237.056)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M330.072,502.819H700.248V606.986H330.072Z",
    transform: "translate(279.013 237.056)",
    fill: "#63805f",
    stroke: "#b8c5b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M330.072,502.819H700.248V942.025H330.072Z",
    transform: "translate(279.013 237.056)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M824.292,740.973H293.55L430.318,378.647H961.06Z",
    transform: "translate(232.786 79.889)",
    fill: "#aac1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M558.431,718.018,520.056,569.092l-28.861,23.4A27.932,27.932,0,1,1,456.643,548.6L647.82,402.52a27.934,27.934,0,0,1,34.271.274l60.889,48.09Z",
    transform: "translate(425.326 102.844)",
    fill: "#63805f",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M824.292,740.973H293.55L430.318,378.647H961.06Z",
    transform: "translate(232.786 79.889)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M433.9,342.333H521v82.275H433.9Z",
    transform: "translate(410.427 33.925)",
    fill: "#1c1931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M433.9,342.333H521v82.275H433.9Z",
    transform: "translate(410.427 33.925)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M424.286,327.795H554.937v32.941H424.286Z",
    transform: "translate(398.262 15.524)",
    fill: "#282642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M424.286,327.795H554.937v32.941H424.286Z",
    transform: "translate(398.262 15.524)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M367.763,653.333V713.15L483.571,560.667h-45.43Zm7.565,70.466h22.716l123.9-163.132H499.225Z",
    transform: "translate(326.719 310.276)",
    fill: "#efe9ad",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M362.763,636.667H584.8v27.189H362.763Z",
    transform: "translate(320.391 406.471)",
    fill: "#aac1a5",
    stroke: "#aac1a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M362.763,632.667H584.8v27.189H362.763Z",
    transform: "translate(320.391 401.408)",
    fill: "#656b82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M1037.83,1152.5H493.453V570.552L765.641,336.53,1037.83,570.552Z",
    transform: "translate(485.808 26.58)",
    fill: "#cbc2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    "data-name": "Path 3610",
    d: "M493.453,570.552v35.259L765.061,375.974l272.768,230.8V570.552L765.641,336.53Z",
    transform: "translate(485.808 26.58)",
    fill: "#aac1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    "data-name": "Path 3611",
    d: "M1037.83,1152.5H493.453V570.552L765.641,336.53,1037.83,570.552Z",
    transform: "translate(485.808 26.58)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    "data-name": "Path 3612",
    d: "M621.334,560.667H784.466V868.806H621.334Z",
    transform: "translate(647.67 310.276)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M685.1,560.667h18.658V868.806H685.1Z",
    transform: "translate(728.379 310.276)",
    fill: "#164712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M621.334,560.667H784.466V868.806H621.334Z",
    transform: "translate(647.67 310.276)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M531.366,560.667H671.841V723.8H531.366Z",
    transform: "translate(533.796 310.276)",
    fill: "#f9f5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    d: "M531.366,696.477l103.145-135.81h-45.43l-57.715,75.99ZM671.841,562.035v-1.369H650.165l-118.8,156.421V723.8h17.618Z",
    transform: "translate(533.796 310.276)",
    fill: "#efe9ad",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M524.366,636.667h172.2v27.189h-172.2Z",
    transform: "translate(524.936 406.471)",
    fill: "#63805f",
    stroke: "#63805f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M531.366,560.667H671.841V723.8H531.366Z",
    transform: "translate(533.796 310.276)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M524.366,632.667h172.2v27.189h-172.2Z",
    transform: "translate(524.936 401.408)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M524.366,632.667h172.2v27.189h-172.2Z",
    transform: "translate(524.936 401.408)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 65.706,
    cy: 65.706,
    r: 65.706,
    transform: "translate(1185.744 553.73)",
    fill: "#f9f5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M623.712,420.662a65.646,65.646,0,0,0-18.126,2.553,65.7,65.7,0,0,1,0,126.305,65.7,65.7,0,1,0,18.126-128.859Z",
    transform: "translate(627.738 133.068)",
    fill: "#efe9ad"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    cx: 65.706,
    cy: 65.706,
    r: 65.706,
    transform: "translate(1185.744 553.73)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M826.844,724.513H609.334V706.387a31.72,31.72,0,0,1,31.72-31.72H795.123a31.72,31.72,0,0,1,31.72,31.72Z",
    transform: "translate(632.482 454.569)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M609.334,687.333h217.51v21.146H609.334Z",
    transform: "translate(632.482 470.601)",
    fill: "#5c6f7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M826.844,724.513H609.334V706.387a31.72,31.72,0,0,1,31.72-31.72H795.123a31.72,31.72,0,0,1,31.72,31.72Z",
    transform: "translate(632.482 454.569)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M109.635,696.667H1893.588",
    transform: "translate(0 482.415)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M1160.332,639.4a21.881,21.881,0,0,1-30.957,2.712L811.189,372.875,493.024,642.107a21.879,21.879,0,1,1-28.267-33.4L777.316,344.214l33.9-28.684,33.85,28.661L1157.643,608.7A21.882,21.882,0,0,1,1160.332,639.4Z",
    transform: "translate(439.681 0)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M1295.356,639.4h0a21.881,21.881,0,0,1-30.957,2.712L946.212,372.875,628.047,642.107a21.881,21.881,0,0,1-30.957-2.712h0A21.878,21.878,0,0,1,599.78,608.7L912.339,344.214l33.9-28.684,33.85,28.661,283.375,239.8,29.206,24.715a21.882,21.882,0,0,1,2.689,30.694Z",
    transform: "translate(304.658 0)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M638.377,583.5h85.9v83.553h-85.9Z",
    transform: "translate(669.242 339.176)",
    fill: "#f9f5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M638.377,647.47l48.584-63.97h-45.43l-3.154,4.151Zm61.447-63.97-61.447,80.9v2.649h9.346L711.182,583.5Z",
    transform: "translate(669.242 339.176)",
    fill: "#efe9ad",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("g", {
    id: "c748e521f8ba28bd1e9381cad2662f22",
    transform: "translate(470.694 718.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M428.019,448.594q-.049-.287-.093-.574Q427.969,448.3,428.019,448.594Zm-.246-1.866c0-.04-.006-.079-.008-.117ZM427.823,447.252Zm.073.566q-.017-.121-.033-.242Q427.879,447.695,427.9,447.818Zm28.391-22.136c-1.536.823-5.306,1.2-5.306,1.2h0c-5.091,6.734-12.451,14.15-22.874,22.2,1.052,5.657,4.062,14.959,4.062,14.959h29.056Zm-28.551,20.091v-.033Zm.369,3.3q-.037-.2-.07-.389Q428.068,448.872,428.1,449.07Z",
    transform: "translate(-117.802 -138.382)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M461.212,432.786l1.7,28.9L459.792,432.9Zm-1.308,1.521-.712,26.212-.712-26.212Zm-1.84,2.04L453.9,465.2l2.748-29.022Z",
    transform: "translate(-131.542 -142.112)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M536.326,273.972a6.317,6.317,0,0,1-3.12-3.83c-.195-.874-1.625-4.774-4.745-2.694s-2.015,4.507-2.015,4.507-1.365-.477-2.47-3.532.553-4.109-5.362-6.32-4.064-5.742-11.605-5.262-6.11,6.316-6.11,6.316l-1.636,1.653c0,.056,0,.111-.011.167-.161,1.317-.734,1.147-1.473,3.467a18.337,18.337,0,0,0-.78,4.594c-.042.66-.01.6,0,3.034.017,4.211-.08,4.3.087,5.287.364,2.155.914,2.232.78,3.467a3.414,3.414,0,0,1-.084.47s2.6,6.2,7.083,6.334c0,0,.975-.932-.975-2.188s-5.631-3.857-4.6-13.608,2-12.091,5.319-13.2c0,0,.845,2.08,4.16,2.665a3.923,3.923,0,0,1,3.445,4.225,3.492,3.492,0,0,0,2.405,3.749c2.47,1,.585,4.648.585,5.715s-.2,3.732,2.21,5.422,1.105,5.315,1.105,5.315,6.7-.7,8.906-9.671c0,0,4.68,6.877,8.19,2.886S538.341,275.036,536.326,273.972Z",
    transform: "translate(-154.16 -49.703)",
    fill: "#aac1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M468.7,298.714a19.915,19.915,0,0,1-.26-2.34c-.034-.765,0-1.387,0-1.387a20.137,20.137,0,0,0,4.421-3.12c.744-.784.939-2.5,1.3-5.894.09-.85.29-2.9.347-6.761a33.975,33.975,0,0,0-.086-5.374c-1.25-4.719-8.32-6.934-8.32-6.934a7.165,7.165,0,0,1-.78,4.16c-.507.918-.959.986-3.9,3.207a15.078,15.078,0,0,0-3.294,2.86,6.41,6.41,0,0,0-1.04,4.767c.327,1.3.927,1.206,2.167,3.64.776,1.523,1.164,2.284,1.126,3.207-.051,1.267-.706,1.49-1.126,3.554a4.2,4.2,0,0,0-.087,2.427c.387,1.047,1.184,1.1,2.167,2.167a6.5,6.5,0,0,1,1.647,3.64c.081,1.475-.665,1.85-1.251,3.559l5.395,3.284,3.129-5.4a9.869,9.869,0,0,1-1.552-3.259Z",
    transform: "translate(-133.14 -55.01)",
    fill: "#3e673b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M345.165,325.405c-.39-.91-.477-6.848-.477-8.148s-1.43-12.914-2.275-18.05-1.235-16.966-1.235-16.966l1.625-3.835.153-.434c-.248-.053.219-3.468.388-4.7.431-3.146.613-3.477.434-4.507-.36-2.068-1.388-2.444-1.127-3.727a2.48,2.48,0,0,1,1.067-1.5c-5.9-1.732-15.542-3.359-15.542-3.359a8.19,8.19,0,0,1-6.327,6.327l-1.56,3.467-1.82-3.38c-5.287-1.474-6.24-11.7-6.24-11.7s-11.614-5.374-13.781-6.371S287.7,233.454,287.7,233.454l3.207-22.588s-5.634-3.553-8.234-3.64-9.707,25.916-10.141,29.794,16.836,27.541,19.5,31.766,3.878,10.466,3.878,10.466l7.823,28.6c-.878,2.34-.13,4.486.585,7.411s-.26,3.576-1.885,5.207,0,5.454-.65,7.275-4.68,21.581-4.68,21.581h53.564s-4.334-13.391-4.421-17.811-.693-5.2-1.083-6.111Z",
    transform: "translate(-36.303 -23.673)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M422.664,346.686a14.625,14.625,0,0,0-1.389,3.919Z",
    transform: "translate(-114.41 -96.902)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M304.238,192.813s.282-.867,2.687-1.691-1.972-4.983,2.513-6.023a30.583,30.583,0,0,0,0,4.03c.173.8,1.322,3.272-.477,4.767s-5.9,4-6.374,3.683a31.826,31.826,0,0,0-6.739-3.152,11.582,11.582,0,0,0,.546-5.341c-.347-3.25,1-7.887,3.337-6.11a2.825,2.825,0,0,1,.986,1.163,5.3,5.3,0,0,1-.206,4.366s-.028.043-.079.108c-.3.383-1.38,1.578-2.3-.108a1.274,1.274,0,0,1,.455-.914,1.261,1.261,0,0,0,.282-1.192m45.287,30.336a22.17,22.17,0,0,1-6.587-.52c-2.34-.433-9.621-3.727-9.621,2.6s-2.86,9.447-2.86,9.447c.26-4.247-2.86-3.467-2.86-3.467s-3.553,3.12.78,5.807c0,0,2.6,2.253,1.474,11.354,0,0,.953,10.227,6.24,11.7l1.82,3.38,1.56-3.467a8.19,8.19,0,0,0,6.327-6.327s-1.387-2.427,0-6.587c0,0,6.24,1.213,5.287-8.668S344.152,216.734,344.152,216.734ZM412.9,250.76s1.3-3.625-1.105-5.315-2.21-4.355-2.21-5.422,1.885-4.719-.585-5.715a3.493,3.493,0,0,1-2.405-3.749,3.923,3.923,0,0,0-3.445-4.225c-3.315-.585-4.16-2.665-4.16-2.665-3.315,1.105-4.29,3.445-5.319,13.2s2.653,12.351,4.6,13.608.975,2.188.975,2.188a4.725,4.725,0,0,1,.084.49,4,4,0,0,1-.669,3.02s-1.56,9.794,5.634,9.707c0,0,5.2-6.674,8.754-9.1,0,0-1.6-1.113-.152-6.017Z",
    transform: "translate(-48.55 -10.733)",
    fill: "#3e673b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M353.635,255.687s2.86-3.12,2.86-9.447,7.28-3.034,9.621-2.6,10.14,2.167,11.094-3.207-5.547-6.5-9.014-5.027-6.24,1.127-10.834.867-3.294,4.16-3.294,4.16-4.247-1.127-3.814,4.073.52,7.714.52,7.714S353.894,251.441,353.635,255.687Z",
    transform: "translate(-77.102 -38.159)",
    fill: "#aac1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M352.87,275.026s-.954.043-.78,1.17.78.607.78.607",
    transform: "translate(-78.071 -59.274)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M369.332,260.978a.356.356,0,0,1-.235-.624,3.634,3.634,0,0,1,4.1-.384.356.356,0,0,1-.366.611,2.867,2.867,0,0,0-3.267.31.357.357,0,0,1-.233.087Zm8.926.737a.356.356,0,0,1-.311-.528,2.349,2.349,0,0,1,1.358-1.045,2.769,2.769,0,0,1,2.171.435.356.356,0,0,1-.368.61,2.1,2.1,0,0,0-1.618-.357,1.642,1.642,0,0,0-.919.7A.356.356,0,0,1,378.258,261.715Zm-8.017,3.337a.356.356,0,0,1-.224-.633,2.233,2.233,0,0,1,2.551-.232.356.356,0,0,1-.407.585c-.769-.534-1.687.194-1.7.2A.355.355,0,0,1,370.242,265.052Zm8.927-.239a.356.356,0,0,1-.224-.633,2.233,2.233,0,0,1,2.55-.232.356.356,0,1,1-.407.585c-.768-.535-1.687.194-1.7.2a.356.356,0,0,1-.223.079Z",
    transform: "translate(-86.948 -51.111)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M383.773,267.318a34.3,34.3,0,0,1,1.861,3.506,7.562,7.562,0,0,1,.725,1.883,3.653,3.653,0,0,1,.046,1.077,1,1,0,0,1-.281.626.352.352,0,0,1-.2.088.289.289,0,0,1-.187-.019.627.627,0,0,1-.246-.163l.04-.086c.177.007.326-.057.276-.114-.01-.046-.032-.181-.067-.31q-.134-.434-.3-.859c-.228-.584-.324-1.231-.516-1.854s-.39-1.248-.6-1.865l-.632-1.87Z",
    transform: "translate(-94.673 -55.227)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M383.58,286.643a3.357,3.357,0,0,1-2.689-1.6.356.356,0,0,1,.6-.378,2.441,2.441,0,0,0,3.213.959.356.356,0,0,1,.337.627A3.066,3.066,0,0,1,383.58,286.643Z",
    transform: "translate(-93.176 -64.246)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M383.674,280.709a10.671,10.671,0,0,1-5.482,0c-1.517.563-3.814-.39-3.814-.39s2.817,3.944,6.414,1.82h.282c3.6,2.124,6.414-1.82,6.414-1.82s-2.3.953-3.814.389Z",
    transform: "translate(-89.785 -62.054)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M380.7,302.517s-6.068-.65-8.148-2.123c0,0,.827,3.256,7.543,5.206a9.531,9.531,0,0,1,.6-3.082Z",
    transform: "translate(-88.827 -72.595)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M373.083,339.358c.164,1.353.276,2.709.38,4.065s.182,2.713.254,4.07.121,2.717.144,4.077l.033,2.04c-.006.681,0,1.361-.017,2.043-.087-.676-.143-1.354-.216-2.031l-.165-2.034c-.109-1.356-.181-2.713-.253-4.071s-.12-2.717-.143-4.076S373.052,340.721,373.083,339.358Z",
    transform: "translate(-89.097 -93.054)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M376.328,341.838a.712.712,0,1,0-.712-.712A.712.712,0,0,0,376.328,341.838Zm.347,5.721a.712.712,0,1,0-.712-.712A.712.712,0,0,0,376.675,347.559Zm.347,4.854a.712.712,0,1,0-.712-.712A.712.712,0,0,0,377.022,352.412Z",
    transform: "translate(-90.435 -93.608)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M334.03,341.9a17.273,17.273,0,0,0,3.415-.833,18.446,18.446,0,0,0,3.193-1.427,17.482,17.482,0,0,0,5.281-4.486,19.521,19.521,0,0,0,3.258-6.134,30.883,30.883,0,0,0,1.394-6.881q-.031.884-.082,1.767c-.066.586-.113,1.175-.194,1.761a25.3,25.3,0,0,1-.771,3.465,19.089,19.089,0,0,1-3.235,6.318,17.219,17.219,0,0,1-5.479,4.511,17.025,17.025,0,0,1-6.781,1.94Zm-15.658,5.374c.537.207,1.073.406,1.621.571.54.182,1.088.344,1.641.479a22.643,22.643,0,0,0,3.342.6,15.349,15.349,0,0,0,3.372-.066,9.842,9.842,0,0,0,1.64-.412,11.029,11.029,0,0,0,1.579-.655,8.584,8.584,0,0,1-3.152,1.426,12.208,12.208,0,0,1-3.484.179,16.149,16.149,0,0,1-3.4-.727A15.645,15.645,0,0,1,318.372,347.278Zm-1.95-9.946q.769.767,1.568,1.5t1.631,1.4c.551.457,1.132.874,1.721,1.282s1.209.771,1.84,1.144a9.166,9.166,0,0,1-2.033-.828,12.169,12.169,0,0,1-1.827-1.229A12.522,12.522,0,0,1,316.422,337.333Zm28.6,19.957c.533-.136,1.066-.264,1.591-.418q.794-.2,1.577-.446c1.042-.322,2.082-.648,3.091-1.051a22.863,22.863,0,0,0,2.952-1.358,7.874,7.874,0,0,0,.7-.416,5.814,5.814,0,0,0,.67-.46,7.942,7.942,0,0,0,.646-.5q.3-.281.607-.555a8.932,8.932,0,0,1-2.431,2.24,15.781,15.781,0,0,1-2.97,1.488,22.3,22.3,0,0,1-3.169.96,21.279,21.279,0,0,1-3.262.512Zm-39-68a21.9,21.9,0,0,1,2.311,2.782,22.366,22.366,0,0,1,1.876,3.106,15.878,15.878,0,0,1,1.265,3.412,8.944,8.944,0,0,1,.168.9l.074.45c.014.151.02.3.029.456a6.926,6.926,0,0,1,0,.91q-.039.451-.093.9-.024-.45-.033-.9a6.764,6.764,0,0,0-.111-.886l-.061-.441-.1-.434a8.628,8.628,0,0,0-.226-.86q-.144-.421-.275-.845l-.326-.828c-.1-.279-.23-.547-.352-.818s-.241-.543-.383-.8a35.7,35.7,0,0,0-1.752-3.115q-.469-.766-.981-1.5C306.722,290.271,306.371,289.784,306.021,289.294Zm-8.841-25.829a2.781,2.781,0,0,1,.662-.728,3.7,3.7,0,0,1,.851-.508,3.069,3.069,0,0,1,.981-.221,1.938,1.938,0,0,1,.974.211,6.993,6.993,0,0,0-.922.156,7.8,7.8,0,0,0-.851.293C298.314,262.9,297.778,263.188,297.18,263.466Z",
    transform: "translate(-49.249 -52.438)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M305.5,189.392c.05-.065.079-.108.079-.108a5.3,5.3,0,0,0,.206-4.366c.076-.112,1.369-1.928,2.04.115.693,2.106-.043,8.635-2.326,4.359Zm4.254-3.816s1.56-1.991,2.109.519-.714,8.219-2.252,3.189",
    transform: "translate(-53.617 -11.513)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M310.209,185.036s1.329-2.383,1.892.347-.55,8.371-2.063,4.6M321.666,291.1s-4.42-2.774-3.033-3.857c0,0,.543-.392,2.9,1.4l.624,2.282Z",
    transform: "translate(-56.001 -11.516)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M330.58,405.137l-.1-.062c-.342-.214-3.343-2.135-3.413-3.484a.878.878,0,0,1,.359-.76c.168-.123.874-.364,3.194,1.394l.064.049.7,2.572Zm-2.819-3.918a.258.258,0,0,0-.075.008.4.4,0,0,0-.142.34c.047.9,2.163,2.447,3.094,3.045l.179-.065-.545-1.992c-1.615-1.213-2.3-1.335-2.51-1.335Z",
    transform: "translate(-64.943 -125.288)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M331.407,411.594s-2.109-.758-.505-1.951c1.117-.83,2.759-1.776,4.1-1.213s.434,1.8-.195,1.863",
    transform: "translate(-66.64 -129.234)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M333.178,415.5s-2.362-.173-1.365-1.43,3.927-1.712,3.927-1.712,3.012-.142.991,1.571",
    transform: "translate(-67.306 -131.384)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M320.02,300.706s-2.88-.071-1.121-1.2,3.405-1.78,3.947-1.486,1.066,1.65-2.826,2.683Zm-14.7-109.086s5.566.978,6.541,1.952c0,0,1.031,2.409-.606,2.729a3.69,3.69,0,0,0-2.383,1.983l-3.552-1.657-1.227-3.835Z",
    transform: "translate(-52.879 -15.479)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M315.12,192.107c-.692,0-1.151-1.224-1.442-2.177l.454-.139c.47,1.537.865,1.879,1.027,1.835.6-.157,1.158-3.115.766-4.9-.14-.64-.355-1.01-.621-1.071-.382-.088-.914.452-1.07.649l-.374-.294c.08-.1.8-.988,1.548-.818.465.106.8.588.98,1.433.375,1.711-.05,5.187-1.11,5.464A.617.617,0,0,1,315.12,192.107Z",
    transform: "translate(-57.912 -12.091)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M310.78,191.217c-.641,0-1.06-1.047-1.206-1.41l.44-.177c.356.888.656,1.15.81,1.105.648-.195,1.226-3.5.8-5.566-.2-.99-.477-1.107-.556-1.119-.265-.045-.693.477-.9.84l-.415-.231c.068-.122.681-1.189,1.383-1.078.446.069.756.557.949,1.493.4,1.95-.012,5.781-1.128,6.117a.622.622,0,0,1-.18.028Z",
    transform: "translate(-55.757 -11.253)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M306.548,190.792c-.743,0-1.354-1.143-1.571-1.551l-.073-.136.1-.122c.025-.032.044-.058.056-.075a5.214,5.214,0,0,0,.2-4.151l-.059-.123.077-.113c.073-.108.738-1.046,1.482-.947.426.06.756.437.981,1.122.5,1.516.337,5.506-.893,6.032a.75.75,0,0,1-.3.063Zm-1.081-1.644c.474.852.9,1.266,1.192,1.145.833-.356,1.13-3.924.628-5.447-.112-.342-.307-.759-.6-.8-.33-.05-.747.384-.945.638a5.665,5.665,0,0,1-.259,4.426Z",
    transform: "translate(-53.306 -11.251)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M446.011,339.322s-.776,1.147-4.126-2.416h0a14.49,14.49,0,0,0-1.4,3.479,11.79,11.79,0,0,0-.173,3.9c.246,1.94.8,2.124.954,3.467.205,1.767-.635,2.448-2.253,6.154-1.355,3.1-2.033,4.653-1.907,6.24.239,3.011,2.525,4.877,2.253,5.114s-2.818-1.3-4.507-4.074c-.686-1.128-1.726-3.278-1.907-13.348-.078-4.326.079-5.9-1.04-8.06-.455-.879-1.975-3.814-4.767-4.16-2.533-.314-4.552,1.694-5.114,2.253a9.242,9.242,0,0,0-1.561,2.092l-1.192,3.1c-.223.868-.307,1.441-.409,1.42-.033-.007-.053-.078-.063-.192l-1.716,4.461.394,8.133s2.629,3.145,5.034,3.632l2.21-2.6-2.21,45.7s19.014-10.527,25.254-14.427c0,0,4.507-26.527,4.854-27.047s-4.854-28.256-4.854-28.256Z",
    transform: "translate(-112.209 -90.179)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M433.168,379.81l3.8-4.225-3.253,7.931Z",
    transform: "translate(-120.655 -112.077)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M422.948,385.941l-4.128,5.6s-.934-6.918-.906-9.233C417.914,382.309,420.673,385.584,422.948,385.941Z",
    transform: "translate(-112.645 -115.607)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M446.749,261.7a7.163,7.163,0,0,1-.78,4.16c-.507.917-.959.986-3.9,3.207a15.082,15.082,0,0,0-3.294,2.86,6.406,6.406,0,0,0-1.04,4.767c.327,1.3.926,1.206,2.167,3.64.776,1.523,1.164,2.284,1.126,3.207-.051,1.267-.706,1.49-1.126,3.554a4.2,4.2,0,0,0-.087,2.427c.387,1.047,1.184,1.1,2.167,2.167a6.5,6.5,0,0,1,1.647,3.64c.1,1.752-.977,1.944-1.56,4.68a11.793,11.793,0,0,0-.173,3.9c.246,1.94.8,2.124.954,3.467.205,1.767-.635,2.448-2.253,6.154-1.355,3.1-2.033,4.653-1.907,6.24.239,3.011,2.525,4.877,2.253,5.113s-2.818-1.295-4.507-4.073c-.686-1.127-1.726-3.278-1.907-13.348-.078-4.326.079-5.9-1.04-8.06-.455-.879-1.975-3.814-4.767-4.16-2.533-.314-4.552,1.694-5.114,2.253-2.756,2.742-2.9,6.665-3.162,6.609s.219-3.468.388-4.7c.431-3.146.613-3.476.434-4.507-.36-2.068-1.389-2.444-1.127-3.727.272-1.333,1.5-1.507,2.6-2.947,1.28-1.677.967-3.215,1.3-5.374.567-3.682,2.137-3.5,4.94-9.534,2.214-4.768,1.4-5.234,3.294-7.887a16.759,16.759,0,0,1,6.327-5.374c1.82-.853,1.773-.273,6.154-1.473,4.1-1.124,4.609-1.715,6.414-1.56a8.819,8.819,0,0,1,5.374,2.6c.455.477,2.672,2.76,2.34,5.46-.161,1.317-.734,1.147-1.474,3.467a18.338,18.338,0,0,0-.78,4.594c-.042.66-.009.6,0,3.034.017,4.211-.08,4.3.086,5.287.365,2.155.915,2.232.78,3.467-.169,1.551-1.072,1.765-2.253,3.9a10.52,10.52,0,0,0-1.56,6.067,11.764,11.764,0,0,0,1.213,3.814c.835,1.843,1.278,1.966,1.733,3.207.878,2.391.429,5.184-.173,5.287-.707.121-.648-3.625-3.727-7.887-.881-1.219-3.027-3.876-3.38-5.807a19.967,19.967,0,0,1-.26-2.34c-.034-.765,0-1.387,0-1.387a20.136,20.136,0,0,0,4.421-3.12c.744-.784.939-2.5,1.3-5.894.09-.85.29-2.9.347-6.761a33.982,33.982,0,0,0-.086-5.374C453.819,263.918,446.749,261.7,446.749,261.7Z",
    transform: "translate(-113.792 -49.809)",
    fill: "#aac1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M442.544,319.378a9.755,9.755,0,0,0,.492-5.148,46.263,46.263,0,0,0-1.652-5.022l-.425-1.271a8.913,8.913,0,0,1-.377-1.338,4.8,4.8,0,0,1,.443-2.736,9.247,9.247,0,0,0,.87-2.5,8.359,8.359,0,0,0,.013-2.616,14.384,14.384,0,0,0-.659-2.536,7.785,7.785,0,0,0-1.195-2.246,12.22,12.22,0,0,1-.787-1.147,6.74,6.74,0,0,1-.577-1.322,8.694,8.694,0,0,1-.4-2.8,11.842,11.842,0,0,1,.42-2.754,20.421,20.421,0,0,1,.852-2.6,12.256,12.256,0,0,1,1.321-2.409,9.4,9.4,0,0,1,1.893-1.955l.065.069a11.8,11.8,0,0,0-2.579,4.553,26.18,26.18,0,0,0-.658,2.552,12.115,12.115,0,0,0-.3,2.555,8.789,8.789,0,0,0,.334,2.5,5.768,5.768,0,0,0,.453,1.152,11.445,11.445,0,0,0,.694,1.09,7.76,7.76,0,0,1,1.184,2.538,12.466,12.466,0,0,1,.456,2.707,10.107,10.107,0,0,1-.214,2.73,12.9,12.9,0,0,1-.9,2.556,4.146,4.146,0,0,0-.317,1.249,3.976,3.976,0,0,0,.107,1.259c.238.788.689,1.61,1.023,2.436s.675,1.661.961,2.52a14.1,14.1,0,0,1,.679,2.665,7.786,7.786,0,0,1-.123,2.773,8.969,8.969,0,0,1-1.009,2.532ZM429.5,289.061a6.792,6.792,0,0,0,2.942-2.793,6.165,6.165,0,0,0,.545-1.92c.084-.687.185-1.4.236-2.076.026-.343.039-.68.037-1.04a4.67,4.67,0,0,1,.1-1.13,6.256,6.256,0,0,1,.919-2.016,8.728,8.728,0,0,1,1.442-1.635,9.192,9.192,0,0,1,1.78-1.281,8.939,8.939,0,0,1,2.063-.806,19.7,19.7,0,0,1,2.138-.366,9.541,9.541,0,0,0,3.779-1.426,34.066,34.066,0,0,0,6.162-5.727l.076.057a27.113,27.113,0,0,1-2.472,3.542,15.581,15.581,0,0,1-3.219,2.981,9.171,9.171,0,0,1-2.018.993,10.34,10.34,0,0,1-2.188.467c-.743.081-1.417.109-2.1.226a9.469,9.469,0,0,0-2,.53,6.765,6.765,0,0,0-3.185,2.612,4.6,4.6,0,0,0-.657,1.936,4.2,4.2,0,0,0,.038,1,9.837,9.837,0,0,1,.09,1.1,9.606,9.606,0,0,1-.056,1.1c-.037.356-.073.716-.139,1.08a5.96,5.96,0,0,1-.73,2.145,5.751,5.751,0,0,1-3.553,2.527Z",
    transform: "translate(-118.731 -54.979)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M447.181,271.465a3.824,3.824,0,0,1-.033-2.288,4.972,4.972,0,0,1,.462-1.078,3.21,3.21,0,0,1,.773-.947,8.162,8.162,0,0,1,2.007-1.179,15.761,15.761,0,0,1,2.136-.755,15.145,15.145,0,0,1,2.235-.419,13.188,13.188,0,0,0,2.191-.282,8.535,8.535,0,0,0,1.037-.356,6.336,6.336,0,0,0,.963-.517c.638-.38,1.258-.793,1.891-1.184s1.253-.8,1.889-1.189,1.262-.772,1.963-1.119a4.65,4.65,0,0,1,1.16-.409,3.424,3.424,0,0,1,1.286,0,4.254,4.254,0,0,1,2.182,1.181,4.388,4.388,0,0,1,1.187,2.157,4.8,4.8,0,0,1-.115,2.4,7.1,7.1,0,0,1-.464,1.072,9.813,9.813,0,0,0-.431,1,6.6,6.6,0,0,0-.285,1.04,6.7,6.7,0,0,0-.085,1.092l-.095.011a5.154,5.154,0,0,1,0-2.276c.155-.746.489-1.485.63-2.113a4.331,4.331,0,0,0-.052-2.007,3.613,3.613,0,0,0-1-1.654,3.568,3.568,0,0,0-1.67-.933,2.792,2.792,0,0,0-1.874.248c-.643.284-1.3.65-1.968.975l-2,.975c-.663.334-1.335.653-1.985,1.011a9.059,9.059,0,0,1-1.013.5c-.35.134-.7.281-1.062.385-.724.233-1.482.34-2.189.507a16.644,16.644,0,0,0-2.084.651,18.035,18.035,0,0,0-3.92,1.754,2.891,2.891,0,0,0-.693.712,5.754,5.754,0,0,0-.527.912,4.151,4.151,0,0,0-.311,1.009,5.017,5.017,0,0,0-.038,1.088Z",
    transform: "translate(-127.912 -51.218)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M481.99,412.562a12.86,12.86,0,0,0,0,6.231s-1.269.79-5.306,1.2c0,0,3.937-5.078,4.891-7.428Z",
    transform: "translate(-143.504 -131.493)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M425.482,372.732c-4.027-2.5-8.2-8.5-8.4-8.747l.458-1.083c.046.06,4.9,6.239,8.7,8.6Z",
    transform: "translate(-112.21 -105.417)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M472.087,323.448s-5.287.347-8.19-2.34c0,0,1.767,3.928,8.273,4.781Z",
    transform: "translate(-136.79 -83.471)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M475.36,309.238a4.221,4.221,0,0,1-3.7-2c-.242-.5-.086-.768.027-.884.14-.143.413-.265.919-.035a5.863,5.863,0,0,0,2.96.406.356.356,0,0,1,.111.7,6.511,6.511,0,0,1-3.352-.454,2.336,2.336,0,0,0,.475.58,3.817,3.817,0,0,0,3,.945.356.356,0,1,1,.076.709A4.847,4.847,0,0,1,475.36,309.238Z",
    transform: "translate(-140.798 -75.64)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M478.948,288.677q1.045,2.039,1.931,4.154l.449,1.071a4.6,4.6,0,0,1,.183.577,1.656,1.656,0,0,1,.01.779,1.131,1.131,0,0,1-.579.7,1.306,1.306,0,0,1-.76.1,1.612,1.612,0,0,1-1.09-.657l.057-.076a2.192,2.192,0,0,0,1.033.066.692.692,0,0,0,.335-.158.243.243,0,0,0,.078-.192,5.329,5.329,0,0,0-.167-.871q-.115-.55-.266-1.092c-.2-.728-.425-1.455-.651-2.18l-.652-2.19Zm17.743,1.145-.652,2.19c-.226.726-.446,1.453-.651,2.18q-.151.542-.266,1.092a5.327,5.327,0,0,0-.167.871.243.243,0,0,0,.078.192.691.691,0,0,0,.336.158,2.19,2.19,0,0,0,1.033-.065l.056.076a1.612,1.612,0,0,1-1.089.658,1.306,1.306,0,0,1-.76-.1,1.13,1.13,0,0,1-.579-.7,1.656,1.656,0,0,1,.01-.779,4.6,4.6,0,0,1,.183-.578l.449-1.071q.886-2.114,1.932-4.155Z",
    transform: "translate(-144.647 -66.442)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M463.5,285.853a.356.356,0,0,1-.264-.595c.07-.078,1.761-1.9,4.945-.656a.356.356,0,1,1-.259.663c-2.729-1.068-4.142.455-4.155.47A.356.356,0,0,1,463.5,285.853Zm13.3-.3a.355.355,0,0,1-.24-.094,2.725,2.725,0,0,0-3.124-.142.356.356,0,0,1-.378-.6,3.359,3.359,0,0,1,3.983.221.356.356,0,0,1-.24.618Z",
    transform: "translate(-136.396 -64.068)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M464.26,292.626a1.313,1.313,0,0,1-.4-.064,1.184,1.184,0,0,1-.442-.279.356.356,0,1,1,.5-.5.475.475,0,0,0,.176.111.591.591,0,0,0,.24.018c.068-.012.1-.04.214-.2a1.73,1.73,0,0,1,.428-.443,2.068,2.068,0,0,1,1.815-.129,2.62,2.62,0,0,1,.866.451.356.356,0,0,1-.44.56,1.9,1.9,0,0,0-.63-.329,1.382,1.382,0,0,0-1.207.034,1.075,1.075,0,0,0-.257.276,1.021,1.021,0,0,1-.662.48,1.121,1.121,0,0,1-.2.017Zm9.191-.229a.356.356,0,0,1-.282-.573,2.629,2.629,0,0,1,.727-.651,2.066,2.066,0,0,1,1.791-.323,1.727,1.727,0,0,1,.524.324c.152.125.187.147.256.14a.58.58,0,0,0,.229-.077.466.466,0,0,0,.142-.151.356.356,0,1,1,.612.365,1.188,1.188,0,0,1-.359.379,1.29,1.29,0,0,1-.574.195,1.016,1.016,0,0,1-.759-.3,1.084,1.084,0,0,0-.317-.2,1.384,1.384,0,0,0-1.178.265,1.912,1.912,0,0,0-.53.475.355.355,0,0,1-.283.139Zm9.43.18a1.3,1.3,0,0,1-.535-.123,1.184,1.184,0,0,1-.405-.331.356.356,0,0,1,.562-.437.469.469,0,0,0,.16.131.594.594,0,0,0,.236.048c.069,0,.1-.028.237-.171a1.725,1.725,0,0,1,.48-.387,2.064,2.064,0,0,1,1.818.095,2.613,2.613,0,0,1,.8.554.356.356,0,1,1-.505.5,1.911,1.911,0,0,0-.585-.4,1.383,1.383,0,0,0-1.2-.115,1.078,1.078,0,0,0-.289.243,1.024,1.024,0,0,1-.716.394Zm12.153.9h-.055a1.023,1.023,0,0,1-.717-.392,1.074,1.074,0,0,0-.29-.242,1.38,1.38,0,0,0-1.2.119,1.913,1.913,0,0,0-.584.406.356.356,0,0,1-.507-.5,2.622,2.622,0,0,1,.8-.557,2.063,2.063,0,0,1,1.817-.1,1.73,1.73,0,0,1,.481.386c.135.143.168.166.237.171a.515.515,0,0,0,.239-.05.471.471,0,0,0,.157-.131.356.356,0,0,1,.563.436,1.187,1.187,0,0,1-.4.332,1.3,1.3,0,0,1-.539.124Z",
    transform: "translate(-136.476 -67.542)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M521.041,322.614a14.886,14.886,0,0,1-8.978,1.561v0c1.6,1.166.721,2.011.721,2.011l0,.008c6.23.7,8.254-3.583,8.254-3.583Z",
    transform: "translate(-162.081 -84.262)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    d: "M528.01,345.8c-2.47-5.515-12-7.659-12-7.659-3.554,2.427-8.754,9.1-8.754,9.1-7.194.086-5.634-9.707-5.634-9.707s-6.219.238-7.735.52a2.3,2.3,0,0,0-1.713,1.961c.14.331.287.659.435.985.835,1.843,1.278,1.966,1.733,3.207.764,2.081.522,4.465.05,5.117,1.012,5.039.781,11.419-2.445,19.019l-.032,4.033,25.568,2.7,3.38-11.658,2.34,6.693,8.84-8.306s-1.56-10.488-4.031-16Z",
    transform: "translate(-151.5 -92.097)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M534.473,415.823l-.621,2.832s-2.146,1.814-8.334,2.207l4.1-5.591Z",
    transform: "translate(-169.147 -132.916)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M524.879,438.908c-2.383-5.461-9.118-16.511-9.118-16.511s-2.147,1.814-8.334,2.207l.046-.062c-4.637,5.629-10.131,10.005-16.407,11.259l3.412,26.509h33.348s-.564-17.941-2.947-23.4Z",
    transform: "translate(-151.056 -136.657)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M515.54,405.625l2.107,28.023-3.525-27.881Zm1.559-1.164,5.027,18.672-6.389-18.251Zm-3.184,2.647L511.1,436.52l1.4-29.513Zm17.019-18.944-1.124-3.5-1.531,12.654Z",
    transform: "translate(-161.575 -116.846)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M529.712,363.68a.475.475,0,0,1-.419-.7l1.43-2.687a.475.475,0,0,1,.838.446l-1.43,2.687a.475.475,0,0,1-.42.252Zm-4.32,1.43a.475.475,0,0,1-.446-.312l-1.043-2.859a.475.475,0,1,1,.893-.326l1.042,2.86a.475.475,0,0,1-.446.638Zm-7.223,11.149a.475.475,0,0,1-.446-.313l-1.042-2.86a.475.475,0,1,1,.893-.325l1.042,2.859a.475.475,0,0,1-.446.638Zm-20.651-16.542a.481.481,0,0,1-.116-.014.475.475,0,0,1-.345-.577l.744-2.951a.475.475,0,0,1,.921.233l-.744,2.951A.475.475,0,0,1,497.518,359.717Zm5.743-6.353a.475.475,0,0,1-.385-.753l1.785-2.466a.475.475,0,1,1,.769.557l-1.785,2.465a.474.474,0,0,1-.385.2Zm-3.028-.306h-.018a.475.475,0,0,1-.457-.492l.112-3.042a.475.475,0,0,1,.95.035l-.112,3.042A.475.475,0,0,1,500.233,353.057Zm-1.914-6.542a.475.475,0,0,1-.389-.746l1.736-2.5a.475.475,0,0,1,.78.541l-1.736,2.5a.474.474,0,0,1-.39.2Zm-3.19-3.994a.475.475,0,0,1-.084-.942l3-.541a.475.475,0,0,1,.169.935l-3,.54A.469.469,0,0,1,495.129,342.522Zm30.74,14.1a.475.475,0,0,1-.419-.7l1.43-2.687a.475.475,0,1,1,.839.446l-1.43,2.686a.475.475,0,0,1-.42.252Z",
    transform: "translate(-152.942 -93.933)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M558.866,365.729s1.7,9.247,6.967,8.792,7.518-2.641,10.379-7.334,10.4-18.117,10.4-18.117l3.164-2.263s1.907-1.777,2.037-3.077c0,0,2.253-.347.563-2.167,0,0,1.777-1.56-.434-2.383,0,0,6.934-3.684,6.327-5.2s-7.757,3.294-7.757,3.294,4.16-6.674,2.514-7.151-6.761,8.711-6.761,8.711a7.738,7.738,0,0,0-4.593,4.463c-1.69,3.727-11.94,12.992-13.76,17.493l-1.173-2.458Z",
    transform: "translate(-186.657 -88.195)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M620.591,353.137c-.622,0-3.092-.849-3.417-2.332l.463-.1c.256,1.163,2.412,1.939,2.935,1.958a15.349,15.349,0,0,0-1.517-2.824c-1.228-2.018-2.456-1.521-2.507-1.5l-.193-.434c.066-.03,1.649-.709,3.106,1.686,1.393,2.288,1.74,2.962,1.528,3.339a.425.425,0,0,1-.4.207Z",
    transform: "translate(-216.844 -97.484)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M620.538,359.8a1.635,1.635,0,0,1-.287-.024.807.807,0,0,1-.7-.484c-.155-.455.284-.975.374-1.075l.353.318c-.146.161-.328.456-.277.6.035.1.222.151.331.171.819.149,2.6-.691,3.213-1.026l.227.417a9.209,9.209,0,0,1-3.238,1.1Z",
    transform: "translate(-218.507 -102.957)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M595.613,353.72a1.452,1.452,0,0,1-1.4-.937c-.168-.4.1-.863.815-1.429l.295.373c-.575.454-.725.747-.673.869a1.076,1.076,0,0,0,1.4.585l.07.222.179.163-.048.051-.062.018a2.039,2.039,0,0,1-.571.085Zm1.523-3.157-.231-.415c1.37-.762,2.791-1.387,2.8-1.393l.191.435C599.886,349.2,598.486,349.812,597.136,350.563Zm.873,1.421,2.142-.848.175.442-2.142.848Zm-22.235,18.6a6.967,6.967,0,0,0-.715,5.346s-2.411-2.541-.458-7.8Z",
    transform: "translate(-194.519 -97.989)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M507.464,285.373a.356.356,0,0,1-.214-.071,2.155,2.155,0,0,0-2.56,0,.356.356,0,1,1-.434-.565,2.856,2.856,0,0,1,3.421,0,.356.356,0,0,1-.214.642Zm8.769,1.308a.355.355,0,0,1-.213-.071,2.155,2.155,0,0,0-2.561,0,.356.356,0,1,1-.434-.565,2.855,2.855,0,0,1,3.421,0,.356.356,0,0,1-.214.641Z",
    transform: "translate(-157.909 -64.073)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M272.525,505.44H435.912v.95H272.525Z",
    transform: "translate(-36.303 -180.262)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M357.088,191.394h-2.527a3.139,3.139,0,0,0-1.954-2.8l.887-2.365A5.677,5.677,0,0,1,357.088,191.394Z",
    transform: "translate(-78.354 -12.646)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M253,306.084l-.324-2.505c1.66-.217,6.341-1.309,8.062-3.715l2.054,1.469C260.073,305.131,253.283,306.047,253,306.084Zm-.161-1.252-.163-1.253h0Z",
    transform: "translate(-25.878 -72.317)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M340.352,166.2l1.233-4.055.347.105L340.7,166.3Z",
    transform: "translate(-71.918)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M580.48,258.65l5.721-5.421.4.425-5.721,5.421Z",
    transform: "translate(-198.006 -47.829)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M295.827,194.26l-.437-.187a11.493,11.493,0,0,0,.527-5.223c-.263-2.464.437-5.77,1.861-6.573a1.594,1.594,0,0,1,1.856.248,3.042,3.042,0,0,1,1.056,1.248,5.538,5.538,0,0,1-.2,4.559l-.023.044s-.032.049-.089.122a1.931,1.931,0,0,1-1.477.857,1.627,1.627,0,0,1-1.222-1l-.028-.088a1.48,1.48,0,0,1,.52-1.1,1.015,1.015,0,0,0,.227-.956l.452-.145a1.494,1.494,0,0,1-.336,1.429,1.228,1.228,0,0,0-.388.689c.253.442.526.676.813.7.473.035.936-.508,1.065-.675l.057-.076a5.215,5.215,0,0,0,.2-4.151,2.637,2.637,0,0,0-.891-1.06,1.172,1.172,0,0,0-1.359-.229c-1.227.693-1.869,3.8-1.622,6.11a11.728,11.728,0,0,1-.563,5.46Zm6.606,3.309a.39.39,0,0,1-.217-.052l.263-.4c.484.089,4.146-2.053,6.091-3.668,1.407-1.17.838-3.044.532-4.051q-.076-.239-.135-.483a25.379,25.379,0,0,1-.021-3.769c-2.016.591-1.734,1.907-1.437,3.3.223,1.041.475,2.222-.747,2.641-2.213.757-2.537,1.537-2.54,1.544l-.449-.153c.032-.1.389-1,2.835-1.841.786-.269.684-.936.437-2.091-.3-1.388-.7-3.289,2.1-3.939l.308-.071-.017.315a27.267,27.267,0,0,0,0,3.967c.025.116.071.267.125.446.313,1.033.967,3.182-.683,4.553C307.617,194.861,303.595,197.568,302.433,197.568Z",
    transform: "translate(-48.309 -10.473)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M433.92,407.589s-.065-2.24,1.631-1.183c1.181.736,2.662,1.919,2.629,3.375s-1.516,1.06-1.806.5",
    transform: "translate(-121.049 -128.112)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M431.153,410.674s-.7-2.262.832-1.793,3.029,3.03,3.029,3.03,1.233,2.753-1.1,1.5",
    transform: "translate(-119.513 -129.526)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M429.813,414.08s-.986-2.707.706-1.481,2.9,2.519,2.825,3.131S432.2,417.325,429.813,414.08Z",
    transform: "translate(-118.743 -131.345)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M492.64,396.512a.759.759,0,1,0-.725-.758.759.759,0,0,0,.725.758Zm4.243-2.3a.759.759,0,1,0-.72-.758.758.758,0,0,0,.72.758Zm3.88-2.789a.759.759,0,1,0-.72-.758.758.758,0,0,0,.72.758Zm3.395-3.395a.758.758,0,1,0-.731-.758A.758.758,0,0,0,504.158,388.025Zm3.516-3.88a.758.758,0,1,0-.725-.758A.759.759,0,0,0,507.674,384.145Zm3.274-4.486a.758.758,0,1,0-.726-.758A.759.759,0,0,0,510.948,379.659Zm2.91-4.85a.758.758,0,1,0-.725-.758A.758.758,0,0,0,513.858,374.809Zm2.3-5.092a.758.758,0,1,0-.732-.758A.759.759,0,0,0,516.161,369.717Zm2.3-4.85a.758.758,0,1,0-.731-.758A.758.758,0,0,0,518.465,364.867Zm1.819-4.608a.758.758,0,1,0-.726-.758.759.759,0,0,0,.726.758Zm1.576-4.85a.758.758,0,1,0-.72-.757A.758.758,0,0,0,521.86,355.41Zm1.333-4.122a.758.758,0,1,0-.725-.758A.758.758,0,0,0,523.193,351.287Z",
    transform: "translate(-151.502 -98.523)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M421.516,360.639l.262,1.417-1.418.262L420.1,360.9Zm2.223,1.848.261,1.418-1.417.261-.261-1.417Zm2.3,2.273.261,1.418-1.417.261-.262-1.417Zm2.121,2.455.262,1.418-1.418.261-.261-1.417Z",
    transform: "translate(-113.792 -104.229)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M423.091,377.262l.262,1.417-1.418.262-.261-1.418Zm-2.351-2.008.261,1.418-1.417.261-.261-1.417ZM418.5,372.7l.261,1.418-1.417.261-.261-1.417Z",
    transform: "translate(-112.21 -110.562)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M331.064,411.554c-.117-.042-1.146-.432-1.255-1.17-.06-.408.171-.81.689-1.194,1.747-1.3,3.206-1.716,4.336-1.242.855.359.864.958.829,1.2a1.4,1.4,0,0,1-1.091,1.119l-.049-.473a.939.939,0,0,0,.67-.716c.043-.29-.14-.522-.542-.692-.965-.4-2.267-.006-3.869,1.185-.252.187-.542.467-.5.743.057.388.719.71.946.793Z",
    transform: "translate(-66.377 -128.97)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M332.905,415.473c-.15-.011-1.469-.127-1.769-.811a.959.959,0,0,1,.236-1c1.042-1.314,3.954-1.78,4.077-1.8.3-.015,1.662-.046,1.921.612.149.377-.094.827-.74,1.375l-.307-.362c.667-.565.621-.8.605-.838-.088-.223-.809-.343-1.432-.314,0,0-2.826.453-3.752,1.622-.171.216-.229.389-.173.518.146.332.986.5,1.37.529Z",
    transform: "translate(-67.051 -131.121)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M335.527,413.313h-.034c-.52-.013-1.744-.1-1.9-.678-.114-.407.323-.741.661-.958,1.539-.986,3.446-1.9,4.189-1.495a.966.966,0,0,1,.491.957c-.071.6-.714,1.46-3.37,2.166Zm2.447-2.759a8.46,8.46,0,0,0-3.468,1.522c-.45.288-.46.429-.46.43a2.445,2.445,0,0,0,1.425.33c2.589-.693,2.951-1.457,2.987-1.754a.489.489,0,0,0-.246-.483A.507.507,0,0,0,337.974,410.554Zm46.681.207a1.393,1.393,0,0,1-1.185-.634l.422-.218a.943.943,0,0,0,.912.362c.285-.066.435-.321.445-.758.024-1.046-.823-2.112-2.517-3.168-.265-.166-.633-.333-.875-.2-.34.195-.4.929-.393,1.171l-.475.013c0-.124-.016-1.225.631-1.6a1.309,1.309,0,0,1,1.363.2c1.847,1.152,2.769,2.357,2.74,3.582-.021.928-.576,1.155-.813,1.21A1.15,1.15,0,0,1,384.655,410.761Z",
    transform: "translate(-68.357 -127.848)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M434.619,413.7a2.436,2.436,0,0,1-1.079-.356l.225-.418c.77.414.969.286,1,.257.176-.163.022-.881-.231-1.448,0,0-1.455-2.464-2.881-2.9-.264-.081-.446-.071-.545.029-.256.257-.105,1.1.009,1.467l-.454.141c-.045-.143-.419-1.414.108-1.943a.959.959,0,0,1,1.02-.147c1.6.49,3.1,3.03,3.164,3.138.122.271.651,1.531.133,2.012A.664.664,0,0,1,434.619,413.7Z",
    transform: "translate(-119.251 -129.252)",
    fill: "#63805f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M432.332,416.336c-.613,0-1.575-.477-2.973-2.379l-.032-.059c-.178-.488-.54-1.661-.065-2.02.337-.254.808.03,1.133.265,1.48,1.072,3.025,2.516,2.922,3.353a.966.966,0,0,1-.711.806A1.08,1.08,0,0,1,432.332,416.336Zm-2.57-2.632c1.591,2.157,2.433,2.213,2.724,2.138a.488.488,0,0,0,.359-.405c.052-.415-.887-1.576-2.729-2.91-.432-.313-.568-.272-.568-.271a2.446,2.446,0,0,0,.214,1.447Z",
    transform: "translate(-118.48 -131.081)",
    fill: "#63805f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M362.763,632.667H584.8v27.189H362.763Z",
    transform: "translate(320.391 401.408)",
    fill: "#63805f",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M367.763,560.667H567.147V723.8H367.763Z",
    transform: "translate(326.717 310.276)",
    fill: "#f9f5cf",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M367.763,560.667H567.147V723.8H367.763Z",
    transform: "translate(326.719 310.276)",
    fill: "none",
    stroke: "#1c1a34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M2743.984,2438.929H2365.72c9.983-18.018,31.2-12.431,54.037-12.912,4.269-13.469,49.014-8.019,74.5-3.872-32.283-29.44-29.507-50.239,26.794-31.387-64.307-87.546,9.761-120.847,24.483-122.6,18.549-2.213,103.821,11.423,58.624,102.589,54.751-22.724,69.731,4.136,28.409,51.4C2672.046,2424,2719.343,2432.665,2743.984,2438.929Z",
    transform: "translate(-706.668 6704.589)",
    fill: "rgba(131,168,127,0.91)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_3643",
    "data-name": "Path 3643",
    transform: "translate(-693.668 6704.589)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2743.984,2438.929H2365.72c9.983-18.018,31.2-12.431,54.037-12.912,4.269-13.469,16.1-13.186,41.581-9.039-32.283-29.44-22.211-58.364,34.09-39.512-64.307-87.546,35.382-107.555,50.1-109.305,18.549-2.213,103.821,11.423,58.624,102.589,54.751-22.724,69.731,4.136,28.409,51.4C2672.046,2424,2719.343,2432.665,2743.984,2438.929Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2644.72900390625 2430.9287109375 C 2640.496826171875 2430.59716796875 2636.305419921875 2430.3291015625 2632.189453125 2430.1357421875 L 2615.63134765625 2429.357666015625 L 2626.54248046875 2416.878662109375 C 2647.481201171875 2392.930908203125 2649.61328125 2378.932373046875 2647.572265625 2374.4365234375 C 2646.1123046875 2371.220947265625 2641.131591796875 2370.5458984375 2637.21044921875 2370.5458984375 C 2631.875 2370.5458984375 2622.341064453125 2371.863037109375 2607.222412109375 2378.137939453125 L 2587.5068359375 2386.32080078125 L 2596.98828125 2367.19580078125 C 2610.8740234375 2339.186279296875 2612.9521484375 2316.98486328125 2603.164306640625 2301.2080078125 C 2590.307373046875 2280.48388671875 2560.229248046875 2275.945556640625 2549.724609375 2275.945556640625 C 2548.46728515625 2275.945556640625 2547.37255859375 2275.996826171875 2546.476318359375 2276.103759765625 C 2532.89599609375 2277.71875 2495.35498046875 2287.200927734375 2484.870361328125 2311.360595703125 C 2477.952392578125 2327.302001953125 2483.673828125 2347.94921875 2501.875732421875 2372.72900390625 L 2516.810791015625 2393.0615234375 L 2492.88818359375 2385.051025390625 C 2481.801025390625 2381.338623046875 2472.340576171875 2379.456298828125 2464.769775390625 2379.456298828125 C 2457.612060546875 2379.456298828125 2452.64404296875 2381.2490234375 2451.48046875 2384.251953125 C 2449.700439453125 2388.845703125 2453.712646484375 2399.1962890625 2466.728515625 2411.06591796875 L 2486.607421875 2429.194580078125 L 2460.052978515625 2424.873046875 C 2452.35498046875 2423.62060546875 2444.424072265625 2422.461181640625 2438.565673828125 2422.461181640625 C 2429.9013671875 2422.461181640625 2428.56103515625 2424.717529296875 2427.383544921875 2428.433349609375 L 2426.592529296875 2430.9287109375 L 2644.72900390625 2430.9287109375 M 2743.98388671875 2438.9287109375 L 2365.719970703125 2438.9287109375 C 2375.259033203125 2421.712890625 2395.054443359375 2426.046875 2416.720703125 2426.047119140625 C 2417.729736328125 2426.047119140625 2418.7412109375 2426.037841796875 2419.75732421875 2426.016357421875 C 2424.02587890625 2412.547119140625 2435.854248046875 2412.830078125 2461.337890625 2416.97705078125 C 2429.055419921875 2387.536865234375 2439.125 2358.612548828125 2495.42822265625 2377.465087890625 C 2431.121337890625 2289.9189453125 2530.81005859375 2269.910400390625 2545.531494140625 2268.15966796875 C 2564.07958984375 2265.949951171875 2649.352294921875 2279.58251953125 2604.15576171875 2370.7490234375 C 2658.9072265625 2348.02490234375 2673.88671875 2374.884765625 2632.56494140625 2422.14453125 C 2672.0458984375 2423.99951171875 2719.3427734375 2432.664794921875 2743.98388671875 2438.9287109375 Z",
    stroke: "none",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M1630.635,2430.209H910.384c46.722-10.854,173.27-16.987,216.821-17.9,8.14-25.685,21.026-22.008,69.617-14.1-61.558-56.138-45.528-115.81,61.829-79.861-122.624-166.937,59.559-196.266,87.631-199.6,35.371-4.218,188.984,7.622,102.8,181.461,104.4-43.331,132.966,7.886,54.172,98C1578.531,2401.736,1605.239,2410.57,1630.635,2430.209Z",
    transform: "translate(-628.342 6720.336)",
    fill: "#83a87f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_3645",
    "data-name": "Path 3645",
    transform: "translate(-628.342 6723.006)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1630.635,2427.536H910.384c46.722-10.854,143.53-23.7,187.081-24.621,8.14-25.685,30.7-25.145,79.287-17.236-61.558-56.138-42.353-111.291,65-75.342-122.624-166.938,67.467-205.091,95.54-208.43,35.371-4.218,197.97,21.783,111.789,195.623,104.4-43.331,132.966,7.886,54.172,98C1578.531,2399.062,1605.239,2407.9,1630.635,2427.536Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1601.991577148438 2419.535888671875 C 1582.322387695312 2410.951416015625 1554.626953125 2405.95068359375 1502.8818359375 2403.525146484375 L 1486.321533203125 2402.7490234375 L 1497.233764648438 2390.26806640625 C 1536.794555664062 2345.021240234375 1544.478759765625 2314.777587890625 1538.478637695312 2301.5615234375 C 1534.09814453125 2291.91259765625 1521.723876953125 2289.88720703125 1512.114624023438 2289.88720703125 C 1496.578735351562 2289.88720703125 1475.84375 2295.0849609375 1452.151123046875 2304.918212890625 L 1432.435791015625 2313.100830078125 L 1441.916870117188 2293.97607421875 C 1469.585205078125 2238.16552734375 1473.434936523438 2193.459716796875 1453.359497070312 2161.10009765625 C 1428.037231445312 2120.283447265625 1371.59619140625 2109.49853515625 1345.289794921875 2109.49853515625 C 1342.562866210938 2109.49853515625 1340.182250976562 2109.619140625 1338.240478515625 2109.8505859375 C 1311.193115234375 2113.067626953125 1236.321533203125 2132.192138671875 1214.96826171875 2181.397216796875 C 1200.675659179688 2214.332275390625 1211.857666015625 2256.120361328125 1248.203369140625 2305.6005859375 L 1263.138671875 2325.933349609375 L 1239.215698242188 2317.922607421875 C 1217.329833984375 2310.59423828125 1198.51513671875 2306.87841796875 1183.294067382812 2306.87841796875 C 1173.298095703125 2306.87841796875 1155.835205078125 2308.668212890625 1151.18994140625 2320.6552734375 C 1145.817993164062 2334.518310546875 1157.967529296875 2357.721435546875 1182.142333984375 2379.767822265625 L 1202.0224609375 2397.897705078125 L 1175.466430664062 2393.5751953125 C 1160.487182617188 2391.13671875 1145.014770507812 2388.880615234375 1133.327758789062 2388.880615234375 C 1114.072021484375 2388.880615234375 1108.39306640625 2394.91259765625 1105.091064453125 2405.331787109375 L 1103.3603515625 2410.79248046875 L 1097.63330078125 2410.9130859375 C 1076.4072265625 2411.35986328125 1041.22021484375 2414.828369140625 1005.6123046875 2419.535888671875 L 1601.991577148438 2419.535888671875 M 1630.634521484375 2427.535888671875 L 910.3838500976562 2427.535888671875 C 957.1058959960938 2416.682373046875 1053.9140625 2403.831787109375 1097.46484375 2402.914794921875 C 1105.60498046875 2377.23046875 1128.160522460938 2377.77001953125 1176.751708984375 2385.678955078125 C 1115.193359375 2329.540771484375 1134.3994140625 2274.388916015625 1241.755859375 2310.336669921875 C 1119.132080078125 2143.39892578125 1309.22314453125 2105.24560546875 1337.295654296875 2101.90673828125 C 1372.668579101562 2097.6884765625 1535.26611328125 2123.689697265625 1449.08447265625 2297.529296875 C 1553.4873046875 2254.198486328125 1582.050170898438 2305.415283203125 1503.25634765625 2395.533935546875 C 1578.530517578125 2399.062255859375 1605.239013671875 2407.896240234375 1630.634521484375 2427.535888671875 Z",
    stroke: "none",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M.127,0C-.35.333.664,83.073.743,185.172.821,286.792-.082,368.459.353,369.552c.386,1.078,2.007-80.366,1.924-183.425C2.242,83.083.508-.36.127,0Z",
    transform: "translate(809.369 8767.516) rotate(-157)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M.127,0C-.35.285.664,71.225.743,158.763.821,245.889-.082,315.909.353,316.846c.386.924,2.007-68.9,1.924-157.265C2.242,71.234.508-.308.127,0Z",
    transform: "matrix(-0.643, 0.766, -0.766, -0.643, 1768.961, 8571.92)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "fed3f94f9df5c1aab78ee8f175a4f949",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1073.281, 8263.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4",
    transform: "translate(9 9.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    d: "M30.966,55.716a2.241,2.241,0,0,1-.258-.014l-5.159-.6a2.089,2.089,0,0,1-1.877-2.3A2.136,2.136,0,0,1,26.065,51l3.62.422,4.972-10.085a2.191,2.191,0,0,1,2.862-.983A2.028,2.028,0,0,1,38.541,43.1L32.908,54.533a2.155,2.155,0,0,1-1.942,1.183Z",
    transform: "translate(-3.167 2.518)",
    fill: "#083d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M33.563,62.183a2.185,2.185,0,0,1-1.594-.68L27.9,57.183a2.01,2.01,0,0,1,.151-2.919,2.21,2.21,0,0,1,3.036.145l4.065,4.32a2.01,2.01,0,0,1-.151,2.919,2.186,2.186,0,0,1-1.442.535Zm16.584-16.56a11.266,11.266,0,0,0-.332-3.421h.02l10.694-7.449L66,40.677,50.4,45.623Z",
    transform: "translate(-1.699 0.371)",
    fill: "#083d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M49.7,51.21a4.311,4.311,0,0,1-.078.723S34.86,40.77,29.992,32.891c-3.343-5.435-.43-8.974,1.681-10.655a9.742,9.742,0,0,1,1.779-1.154l.508-.2.45-.176h.02a16.169,16.169,0,0,0,2.463,4.673C41.9,32.05,47.881,41.1,49.367,47.789A11.265,11.265,0,0,1,49.7,51.21Z",
    transform: "translate(-1.252 -5.216)",
    fill: "#42b38f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M57.369,56.344C51.6,64.712,8.081,36.617,18.463,19.666c0,0-4.692-2.444-9.463-4.5l11.75-.235a10.473,10.473,0,0,1,13.588-4.3A10.313,10.313,0,0,1,39.6,16.323c1.271,3.3,1.623,6.022,2.542,8.72,0,.02.02.059.02.078l-.411.156-.547.215a9.742,9.742,0,0,0-1.779,1.154C37.31,28.328,34.4,31.866,37.74,37.3,42.608,45.181,57.369,56.344,57.369,56.344Z",
    transform: "translate(-9 -9.627)",
    fill: "#0d7982"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M38.794,25.043l-.391.235-2.327,1.369a74.4,74.4,0,0,0-5.337-11.711c-3.441-6-13.334,0-13.334,0a10.473,10.473,0,0,1,13.588-4.3,10.313,10.313,0,0,1,5.259,5.689C37.524,19.627,37.876,22.345,38.794,25.043Z",
    transform: "translate(-5.655 -9.627)",
    fill: "#083d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M48.788,51.21c-.978-5.2-18.026-28.975-18.026-28.975l2.288-1.349.45-.176h.02a16.169,16.169,0,0,0,2.463,4.673C40.988,32.05,46.97,41.1,48.456,47.789A11.265,11.265,0,0,1,48.788,51.21Z",
    transform: "translate(-0.341 -5.216)",
    fill: "#20894a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(9 10.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M52.936,59.381c-4.728,0-11.345-3.1-16.767-6.628C23.528,44.534,13.242,32.22,17.289,22.358c-1.674-.837-4.42-2.172-7.172-3.347a1.844,1.844,0,0,1,.687-3.538l10.087-.207a11.766,11.766,0,0,1,14.626-3.889,11.631,11.631,0,0,1,5.894,6.349,40.772,40.772,0,0,1,1.53,5.125,17.571,17.571,0,0,0,2.969,7.141h0C55,42.117,59.149,51.011,58.247,56.428a1.843,1.843,0,0,1-.3.743,5.692,5.692,0,0,1-5.01,2.21ZM18.806,19c1.062.529,1.738.882,1.809.918a1.842,1.842,0,0,1,.718,2.6c-4.656,7.611,4.951,19.42,16.846,27.153,8.572,5.574,14.9,6.812,16.49,5.66.311-4.361-3.914-12.724-11.707-23.12h0a21,21,0,0,1-3.6-8.466,37.286,37.286,0,0,0-1.389-4.683A8.016,8.016,0,0,0,23.523,18a1.847,1.847,0,0,1-1.566.934Z",
    transform: "translate(-9 -10.262)",
    fill: "#3b1f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M49.116,53.717a1.835,1.835,0,0,1-1.11-.374c-.58-.439-14.236-10.831-18.942-18.458a9.3,9.3,0,0,1-1.386-7.7A10.931,10.931,0,0,1,33.1,21.124a1.843,1.843,0,1,1,1.582,3.329,7.232,7.232,0,0,0-3.473,3.8,5.81,5.81,0,0,0,.992,4.692C36.549,40,50.1,50.3,50.23,50.406a1.843,1.843,0,0,1-1.114,3.311Z",
    transform: "translate(-1.688 -6.011)",
    fill: "#3b1f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M50.736,47.856a1.843,1.843,0,0,1-1.123-3.3,1.843,1.843,0,0,1-.479-3.263l10.089-7.022a1.839,1.839,0,0,1,2.4.259L66.789,40.1a1.843,1.843,0,0,1-.794,3.009l-14.7,4.663a1.829,1.829,0,0,1-.558.086Zm9.277-9.65-7.735,5.385,9.833-3.119ZM30.4,57.784a1.824,1.824,0,0,1-.221-.013l-4.415-.534a1.844,1.844,0,1,1,.443-3.66l3.1.376,4.269-8.995a1.843,1.843,0,0,1,3.329,1.58L32.061,56.732A1.844,1.844,0,0,1,30.4,57.784Z",
    transform: "translate(-2.977 -0.843)",
    fill: "#3b1f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M32.634,55.882a1.842,1.842,0,0,1-1.362-.6l-3.495-3.837A1.843,1.843,0,0,1,30.5,48.961L34,52.8a1.843,1.843,0,0,1-1.362,3.085Z",
    transform: "translate(-1.72 4.897)",
    fill: "#3b1f51"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_3f97935fc5a717f70592f07eaff41939",
    "data-name": "3f97935fc5a717f70592f07eaff41939",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 1455.324, 8036.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M365.1,365.906H26.545c-18.866,0-30.69-21.838-21.192-39.283l41.868-77.016L174.7,17.01a23.647,23.647,0,0,1,42.255,0l127.477,232.6,42.061,76.951C396.117,344.068,383.971,365.906,365.1,365.906Z",
    transform: "translate(5.451 5.365)",
    fill: "#f2c766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M31.544,22H65.271a2.714,2.714,0,0,1,2.52,3.1L50.863,161.753a2.455,2.455,0,1,1-4.91,0L29.024,25.1a2.714,2.714,0,0,1,2.52-3.1Z",
    transform: "translate(152.868 103.751)",
    fill: "#fdbe30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 19.026,
    cy: 19.891,
    rx: 19.026,
    ry: 19.891,
    transform: "translate(182.62 286.669)",
    fill: "#fdbe30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M240.734,19.338C235.556,9.3,212.566,3,201.276,3a30.173,30.173,0,0,0-26.813,16.336L5.183,328.887A33.921,33.921,0,0,0,5.7,362.42,30.5,30.5,0,0,0,32,377.732H370.555a30.5,30.5,0,0,0,26.3-15.313,34.114,34.114,0,0,0,.582-33.533ZM385.739,355.829a17.574,17.574,0,0,1-15.184,8.981L25.946,355.829c-6.306-.053-6.05,5.5-9.134,0-3.819-6.355,5.515-20.471,9.134-26.943L148.3,93.435c2.926-5.887,46.4-77.5,52.975-77.5S249.581,77,252.507,82.892l133.555,252.2a20.675,20.675,0,0,1-.323,20.74Z",
    transform: "translate(0 0)",
    stroke: "#333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M45.01,167.989a8.852,8.852,0,0,0,8.852,8.076,8.981,8.981,0,0,0,8.916-8.076L79.706,31.4a9.5,9.5,0,0,0-2.261-7.366A8.852,8.852,0,0,0,70.983,21H37a8.852,8.852,0,0,0-6.461,3.037c-1.854,1.982-.251,45.161,0,47.864ZM66.267,33.922,53.861,134.585,37,33.922ZM53.861,184.59c-14.273,0-25.844,9.508-25.844,23.781a25.844,25.844,0,0,0,51.688,0C79.706,194.1,68.135,184.59,53.861,184.59Zm-3.057,40.7c-7.137,0-12.635-12.079-12.635-19.216s8.555-10.627,15.692-10.627,15.256,8.558,15.256,15.694S57.941,225.291,50.8,225.291Z",
    transform: "translate(147.414 98.29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyError);
export default __webpack_public_path__ + "static/media/familyError.b082ff524bb38adbc9983aa1158e6b58.svg";
export { ForwardRef as ReactComponent };